module.exports = __webpack_public_path__ + "img/21_33.ac3cca1d.png";